/*TODO
    Nice-to-haves:
    -"show more" at bottom (pretty much pagination) and/or automatically get more results [upon scrolling to the bottom of grid] or [set interval]
    -show total record count: optionally send back total record count
    -export as csv (possibly essentially change the MIME type to text/csv or something 

-dependents: 
-JQuery, Json2.js, All.js, bootstrap (icons, buttons, etc.)

-set editing, inserting, deleting stuff (see example)
-call grid.Init() with three params:
    -$table: jquery object pointing to html table
    -columns: column: { HeaderText: "", DataField: "" }
    -dataSourceURL: string to your Server side code to handle all requests from JohnGrid

-editing/inserting/deleting: 
-edit and insert template can be the same
-save method serializes the insert or edit template and sends the yielded object to the server with method set to "save" 
    (up to you to check if PrimaryKey is nullorwhitespace to distinguish between inserts and updates)
-JohnGrid requires the dataSourceURL to accept a request value, "method", which will be set to "getAll" 
    (should give the grid its datasource), "getSingle" (passes item.PrimaryKey), "save" (passesItem, using 
    JQuery serializeArray to get values from edit or insert template), or "delete" (passes item.PrimaryKey)
*/
define('johngrid',['require','all'],function (require) {
	require('all');
	function CreateJohnGrid() {
		var JohnGrid = {
			$table: null,
			$tbody: null,
			$loadingTemplate: null,
			columns: [],
			datasourceURL: "getMaStuff.aspx",
			currentDataSource: [],
			dsPostValues: {},
			pkColumnName: "PrimaryKey",

			init: function ($table, columns, datasourceURL) {
			    this.$table = $table;
			    this.cancelClass = ".btnCancel";

				this.$table.html("<thead></thead><tbody></tbody>");
				this.columns = columns == null ? [] : columns;
				this.allowSubGrid = this.columns.some(this._hasSubGrid);
				if (this.allowSubGrid) {
				    this.subColumns = this.columns.filter(this._hasSubGrid)[0].SubGrid;
				}
				this.datasourceURL = datasourceURL;

				this.$tbody = $("tbody", $table);
				JohnGrid.utilities.setUpCancelBtn();

				this.$loadingTemplate = $("<div style='display:none;'><h4>Loading...</h4></div>");
				this.$loadingTemplate.insertAfter(this.$table);

				this.utilities.init();

				this.buildHeader();
			},

            /**
             * Clear this john grid's handlers--ie8 leaks...
             */
            unload: function() {
                $('.btnAddNew', this.$table).off('click');
                $('.btnRefresh', this.$table).off('click');
                $('.sortAnchor', this.$table).off('click');
                $('.btnSave', this.$table).off('click');
                $(this.cancelClass, this.$table).off("click");
                $("a.btnEdit", this.$table).off("click");
                $("a.btnDelete", this.$table).off("click");
                $("a.btnSelect", this.$table).off("click");
                if (this.allowSubGrid) {
                    $('tr.parent', this.$table).off('click');
                }
            },

            /**
             * When you want to go right into an item, upon initializing the grid, call this. 
             * If primaryKey is an object, no ajax request will be done. That object will simply be used.
             * If primaryKey is not set to a valid value, simply return. That way, we can call this without needing to check.
             * 
             * @param {string|int|guid|object} primaryKey  
             * @param {string} mode (optional)
             *          Inserting throws error, since you can simply call addClick
             *          Editing causes grid to be set into edit mode, load the item by primary key and then call the onEdit handler
             *          Selecting is the same as editing except the onSelecting handler is called and the grid is set to selecting mode
             */
			loadItem: function (primaryKey, mode) {
                if (primaryKey == null || primaryKey === 0 || primaryKey === '') {
                    return; 
                }
                if (mode === JohnGrid.utilities.gridModes.inserting) {
                    throw new Error("If you want johngrid in add mode upon load, simply call: JohnGrid.insertHelpers.addClick();");
                }

                JohnGrid.utilities.gridMode = mode || JohnGrid.utilities.gridModes.editing;
                JohnGrid.utilities.clearForm();

                var item = {}
			    var isLoaded = $.isPlainObject(primaryKey);
                if (isLoaded) {
                    item = primaryKey;
                } else {
                    item[JohnGrid.pkColumnName] = primaryKey;
                }
                JohnGrid.utilities.selectedItem = item; //delta item with only primary key, so we can getsingle
			    console.log(JohnGrid.utilities.selectedItem);

                JohnGrid.selectHelpers.getSingle(function () {
                    JohnGrid.utilities.gridMode === JohnGrid.utilities.gridModes.editing ?
                        JohnGrid.editHelpers.onEdit(JohnGrid.utilities.selectedItem) :
                        JohnGrid.selectHelpers.onSelect(JohnGrid.utilities.selectedItem);
                }, JohnGrid.editHelpers.useDataSourceItem || isLoaded);
            },

			showTopRow: true,
			buildHeader: function () {
				//top buttons
				var headerButtons = "";
				if (JohnGrid.showTopRow) {
					if (JohnGrid.insertHelpers.allowInsert) {
						headerButtons = "<button type='button' class='btnAddNew btn btn-small'> <i class='icon-plus-sign'></i>&nbsp;Add New</button>&nbsp;";
					}
					if (JohnGrid.datasourceURL != undefined) { //only have refresh button if we have datasource url
						headerButtons += "<button type='button' class='btnRefresh btn btn-small' style='margin-right:5px;'> <i class='icon-refresh'></i> Refresh</button>" + JohnGrid.htmlHelpers.loadingImg(false);
					}
				}

				//header columns
				var headers = [],
					plainHeader = "<th{3}>{0}</th>",
					sortableHeader = "<th{3}><a class='sortAnchor' data-column='{1}' data-type='{2}' title='Sort' href='#'>{0}</a>&nbsp;</th>";

				if (this.selectHelpers.allowSelect) headers.push("<th></th>");
			    for (var j = 0, length = this.columns.length; j < length; j++) {
			        var column = this.columns[j];
				    var template = this.sorting.allowSorting && column.AllowSorting != false ? sortableHeader : plainHeader,
				        headerText = column.HeaderText != null ? column.HeaderText : column.DataField,
				        sortColumn = column.SortField != null ? column.SortField : column.DataField,
				        dataType = column.DataType != null ? column.DataType : "";
			        var style = column.Width != null ? ' style="width:{0}px;"'.format(column.Width) : '';
				    headers.push(template.format(headerText, sortColumn, dataType, style));
				}
				if (this.editHelpers.allowEdit) headers.push("<th></th>");
				if (this.deleteHelpers.allowDelete) headers.push("<th></th>");

				//set header html
				var thead = $("thead", this.$table),
					canRefresh = headerButtons != "",
					topRowTemplate = "<tr><td class='johnGridHeader' colspan='{0}'>{1}</td></tr>",
					topRowHtml = canRefresh ? topRowTemplate.format(this.getColSpanNumber(), headerButtons) : "",
					headerRow = "<tr>{0}</tr>".format(headers.join(""));

				thead.html(topRowHtml + headerRow);

				//add handlers
				$(".btnAddNew", thead).on("click", this.insertHelpers.addClick);
				$(".btnRefresh", thead).on("click", function () { JohnGrid.databind(); });
				$(".sortAnchor", thead).on("click", this.sorting.sortClick);
			},
			setGridLoading: function (loading) {
				var loadingImg = $(".btnRefresh", this.$table).next();
				loading ? loadingImg.show() : loadingImg.hide();
			},
			databind: function (optionalStaticDataSource) {
				JohnGrid.utilities.clearMessage();
				JohnGrid.setGridLoading(true);

				JohnGrid.onDataBinding();

				if (optionalStaticDataSource == undefined) {
					JohnGrid.refreshDatasource(function (dataSource) {
						JohnGrid.createRows(dataSource);
					});
				} else {
					JohnGrid.createRows(optionalStaticDataSource);
				}
			},
			_generateColumns: function (dataSource) {
                var generatedColumns = [];
				var exampleItem = dataSource[0];
                for (column in exampleItem) {
                    generatedColumns.push({ DataField: column });
                }
                return generatedColumns;
            },
			createRows: function (dataSource) {
			    //generate columns definition if none defined
			    if (dataSource.length > 0) {
			        if (this.columns.length === 0) {
			            this.columns = JohnGrid._generateColumns(dataSource);
			            this.buildHeader();
			        }
			        if (this.allowSubGrid && !Array.isArray(this.subColumns)) {
			            this.subColumns = JohnGrid._generateColumns(dataSource[0].SubGrid);
			        }
			    }

				JohnGrid.currentDataSource = dataSource;
				JohnGrid.onCreatingRows();

				var itemCount = JohnGrid.currentDataSource.length,
					sortColumnInfo = JohnGrid.sorting.getSortColumnIndex(),
					sortColumnIndex = -1;

				if (sortColumnInfo != null) {
					sortColumnIndex = sortColumnInfo.index;
					JohnGrid.sorting.setSortIcon(sortColumnInfo.column, JohnGrid.dsPostValues.sortClause);
				} else {
					JohnGrid.sorting.setSortIcon("", undefined);
				}

				if (itemCount > 0) {
				    var rows = [];
				    var rowClass = this.allowSubGrid ? ' class="parent"' : '';
				    var rowTitle = this.allowSubGrid ? ' title="expand"' : '';
					for (var i = 0; i < itemCount; i++) {
						var item = JohnGrid.currentDataSource[i],
							row = [],
							tdTemplate = "<td{0}>{1}{2}</td>";

						row.push("<tr data-itemIndex='{0}'{1}{2}>".format(i, rowClass, rowTitle));
						if (JohnGrid.selectHelpers.allowSelect) row.push("<td><a href='#' class='btnSelect'>Select</a></td>");
						for (var j = 0, columnCount = JohnGrid.columns.length; j < columnCount; j++) {
							var column = JohnGrid.columns[j],
								rawValue = item[column.DataField],
								value = rawValue == null ? "" : rawValue,
								showSorted = j == sortColumnIndex,
								sortClass = showSorted ? ' class="sorted"' : '';
							var expandedIcon = this._hasSubGrid(column) ? '<i class="icon-chevron-right">' : '';
							row.push(tdTemplate.format(sortClass, value, expandedIcon));
						}
						if (JohnGrid.editHelpers.allowEdit) row.push("<td><a href='#' class='btnEdit'><i class='icon-pencil'></i></a></td>");
						if (JohnGrid.deleteHelpers.allowDelete) row.push("<td><a href='#' class='btnDelete'><i class='icon-trash'></i></a></td>");
						row.push("</tr>");
						if (this.allowSubGrid) {
						    //generate html for sub grid using a child johngrid...
						    var subGrid = CreateJohnGrid();
						    var subContainer = $('<div><table class="table table-condensed"></table></div>');
						    subGrid.init($('table', subContainer), this.subColumns);
						    subGrid.databind(item.SubGrid);
						    row.push('<tr class="sub-grid"><td colspan="{0}">{1}</td></tr>'.format(this.getColSpanNumber(), subGrid.$table.parent().html()));
						}
						rows.push(row.join(""));
					}
					JohnGrid.$tbody.html(rows.join(""));
					JohnGrid.setGridLoading(false);
				} else {
					JohnGrid.setGridLoading(false);
					JohnGrid.setGrid(JohnGrid.UIComponents.NoRecordsText);
				}

				//reset click handlers
				$("a.btnEdit", JohnGrid.$table).on("click", JohnGrid.editHelpers.editClick);
				$("a.btnDelete", JohnGrid.$table).on("click", JohnGrid.deleteHelpers.deleteClick);
				$("a.btnSelect", JohnGrid.$table).on("click", JohnGrid.selectHelpers.selectClick);
				if (this.allowSubGrid) {
			        $('tr.parent', JohnGrid.$table).on('click', JohnGrid.selectHelpers.onRowClick);
			    }
			    JohnGrid.onDataBound();
			},
			onDataBinding: function () { },
			onCreatingRows: function () { },
			onDataBound: function () { },
			getColSpanNumber: function () {
			    var colspan = this.columns.length;
				if (this.editHelpers.allowEdit) colspan++;
				if (this.deleteHelpers.allowDelete) colspan++;
				if (this.selectHelpers.allowSelect) colspan++;
				return colspan;
			},
            /**
             * Subgrid can be a boolean or an array of defined columns. If it's a boolean, the columns are inferred from the datasource items' SubGrid array.
             * @param {obj} c 
             * @returns {bool} 
             */
            _hasSubGrid: function (c) { return c.SubGrid != null; },
			setGrid: function (message) {
				var colspan = this.getColSpanNumber();
				this.$tbody.html("<tr><td colspan='{0}'>{1}</td></tr>".format(colspan, message));
			},
			refreshDatasource: function (callback) {
				this.dsPostValues.method = "getAll";
				$.ajax({
					url: this.datasourceURL,
					type: 'POST',
					dataType: 'text',
					data: this.dsPostValues,
					cache: false,
					success: function (response) {
						JohnGrid.utilities.handleResponse(response, callback);
					},
					error: function (xhr) {
					    JohnGrid.utilities.setError(xhr, "Something went wrong, while retrieving the data.");
						JohnGrid.setGridLoading(false);
					}
				});
			},

			selectHelpers: {
				allowSelect: false,
				$detailTemplate: null,
				init: function ($detailTemplate) {
					this.allowSelect = true;
					this.$detailTemplate = $detailTemplate;
					JohnGrid.utilities.addActionItems($detailTemplate);
				},
				useDataSourceItem: false,
				selectClick: function (e) {
					e.preventDefault();
					var selectAnchor = $(this),
						item = JohnGrid.utilities.getItemForRowClick(selectAnchor);
				    JohnGrid.loadItem(item[JohnGrid.pkColumnName], JohnGrid.utilities.gridModes.selecting);
				},
                /**
                 * when toggling the subgrid, also toggle the indicator icon
                 * @param {event} e 
                 */
				onRowClick: function (e) {
				    var subRow = $(this).next();
				    var showing = subRow.is(':hidden');
				    var findClass = 'icon-chevron-' + (showing ? 'right' : 'down');
				    var newClass = 'icon-chevron-' + (!showing ? 'right' : 'down');
				    subRow.toggle().prev().find('.' + findClass).addClass(newClass).removeClass(findClass);
			    },
				onSelect: function (item) {},
				getSinglePostValues: { method: "getSingle" },
				getSingle: function (callBack, useDataSourceItem) {
					JohnGrid.utilities.clearMessage();

					if (useDataSourceItem) {
						JohnGrid.selectHelpers.fillForm(callBack);
					} else {
						JohnGrid.$loadingTemplate.show();
						JohnGrid.$table.hide();
						JohnGrid.selectHelpers.getSinglePostValues[JohnGrid.pkColumnName] = JohnGrid.utilities.selectedItem[JohnGrid.pkColumnName];

						$.post(JohnGrid.datasourceURL, JohnGrid.selectHelpers.getSinglePostValues, function (response) {
							JohnGrid.utilities.handleResponse(response, function (item) {
								JohnGrid.utilities.selectedItem = item;
								JohnGrid.selectHelpers.fillForm(callBack);
							});
						}).complete(function () {
							JohnGrid.$loadingTemplate.hide();
						});
					}
				},
				fillForm: function (callBack) {
					//fill in all form elements
					var context = JohnGrid.utilities.getContext();
					if (context != null) {
					    console.log(JohnGrid.utilities.selectedItem);
						var item = JohnGrid.utilities.selectedItem;
						for (var property in item) {
							var rawValue = item[property];
							if (typeof rawValue != "object") {
								var value = Utilities.htmlDecode(rawValue),
									dataNameField = $("[data-name='{0}']".format(property));

								if (dataNameField.length > 0) {
									var isHTML = dataNameField.attr("data-html") != undefined;
									isHTML ? dataNameField.html(rawValue) : dataNameField.text(value);
								}

								$("input[name='{0}']:not(input[type='checkbox'], input[type='radio'])".format(property), context).val(value);
								$("select[name='{0}'] option[value='{1}']".format(property, escape(value)), context).prop('selected', true);
								var checkBox = $("input[type='checkbox'][name='{0}']".format(property), context);
							    checkBox.prop("checked", rawValue);

								var textArea = $("textarea[name='{0}']".format(property), context);
								if (textArea.length > 0) {
									var isHTML = textArea.attr("data-html") != undefined;
									isHTML ? textArea.val(rawValue) : textArea.val(value);
								}
							}
						}

						JohnGrid.utilities.swap(context, JohnGrid.$table);
						if (callBack != undefined) callBack.call();
					}
				}
			},

			editHelpers: {
				allowEdit: false,
				$editTemplate: null,
				init: function ($editTemplate) {
					this.allowEdit = true;
					this.$editTemplate = $editTemplate;
					JohnGrid.utilities.addActionItems($editTemplate);
				},
				useDataSourceItem: false,
				editClick: function (e) {
					e.preventDefault();
					JohnGrid.utilities.gridMode = JohnGrid.utilities.gridModes.editing;
					var editAnchor = $(this),
						item = JohnGrid.utilities.getItemForRowClick(editAnchor);
					JohnGrid.loadItem(item[JohnGrid.pkColumnName], JohnGrid.utilities.gridModes.editing);
				},
				onEdit: function (item) {
					//user implement this to fill in his template...
				}
			},

			insertHelpers: {
				allowInsert: false,
				$insertTemplate: null,
				init: function ($insertTemplate) {
					this.allowInsert = true;
					this.$insertTemplate = $insertTemplate;
					JohnGrid.utilities.addActionItems($insertTemplate);
				},
				addClick: function (e) {
					JohnGrid.utilities.gridMode = JohnGrid.utilities.gridModes.inserting;
					JohnGrid.utilities.selectedItem = null;
					JohnGrid.utilities.clearForm();
					JohnGrid.insertHelpers.onAdd();
					JohnGrid.utilities.swap(JohnGrid.insertHelpers.$insertTemplate, JohnGrid.$table);
				},
				onAdd: function () {
					//user implement this to do anything, while we're switching to the insert form..
				}
			},

			deleteHelpers: {
				allowDelete: false,
				deleteClick: function (e) {
					e.preventDefault();
					if (confirm("Are you sure you'd like to delete this?")) {
						JohnGrid.utilities.clearMessage();
						var deleteAnchor = $(this),
							item = JohnGrid.utilities.getItemForRowClick(deleteAnchor),
							loading = $(JohnGrid.htmlHelpers.loadingImg(true));

						deleteAnchor.parent().append(loading);
						deleteAnchor.hide();

						var data = { method: "delete" };
						data[JohnGrid.pkColumnName] = item[JohnGrid.pkColumnName];

						$.post(JohnGrid.datasourceURL, data, function (response) {
							JohnGrid.utilities.handleResponse(response, function (respObj) {
								JohnGrid.utilities.setInfo("Deleted Successfully");
								JohnGrid.databind();
							});
						}).error(function (xhr) {
							JohnGrid.utilities.setError(xhr, "Something went wrong, while deleting.");
						}).complete(function () {
							loading.remove();
							deleteAnchor.show();
						});
					}
				}
			},

			sorting: {
				allowSorting: false,
				sortClientSide: false,
				sortingColumn: null,
				sortClick: function (e) {
					e.preventDefault();
					var $sortAnchor = $(this),
						sortClause = JohnGrid.dsPostValues.sortClause == undefined ? "" : JohnGrid.dsPostValues.sortClause, //3 possible states: "", "[fieldName]", "[fieldName DESC]"
						columnName = $sortAnchor.attr("data-column"),
						newSortClause = "",
						sortAsc = sortClause.indexOf(" DESC") != -1;

					JohnGrid.sorting.sortingColumn = sortClause.replace(" DESC", "");
					var switchingColumns = !(JohnGrid.sorting.sortingColumn == null || JohnGrid.sorting.sortingColumn == columnName);
					JohnGrid.sorting.sortingColumn = columnName;

					if (sortClause == "" || switchingColumns) {
						newSortClause = columnName + " DESC";
					} else if (sortAsc) {
						newSortClause = columnName;
					} else {
						newSortClause = "";
					}
					JohnGrid.dsPostValues.sortClause = newSortClause;

					if (JohnGrid.sorting.sortClientSide) { //does not handle undefined and should consider defining datatype on column, rather than determining it, based on each data row (confirmation numbers might be numeric or not...)
						var dataType = $sortAnchor.attr("data-type");

						JohnGrid.currentDataSource.sort(function (a, b) {
							var aVal = a[columnName],
							bVal = b[columnName];

							switch (dataType) {
								case "int":
									aVal = parseInt(aVal);
									bVal = parseInt(bVal);
									break;
								case "float":
									aVal = parseFloat(aVal);
									bVal = parseFloat(bVal);
									break;
								case "date":
									aVal = Date.parse(aVal);
									bVal = Date.parse(bVal);
									break;
								default: //sort alphabetically, case insensitive
									aVal = aVal.toString().toLowerCase();
									bVal = bVal.toString().toLowerCase();
									break;
							}

							if (aVal < bVal) return -1;
							if (aVal > bVal) return 1;
							return 0;
						});

						if (!sortAsc && !(sortClause == "" || switchingColumns)) {
							JohnGrid.currentDataSource.reverse();
							JohnGrid.dsPostValues.sortClause = columnName + " DESC";
						} else {
							JohnGrid.dsPostValues.sortClause = columnName; //never goes back to order they came in...
						}

						JohnGrid.databind(JohnGrid.currentDataSource);
					} else {
						JohnGrid.databind();
					}
				},
				getSortColumnIndex: function () {
					var sortClause = JohnGrid.dsPostValues.sortClause;
					if (sortClause != undefined && sortClause != "") {
						var sortColumn = sortClause.replace(" DESC", "");

						for (var i = JohnGrid.columns.length - 1; i >= 0; i--) {
							var column = JohnGrid.columns[i],
								sortField = column.SortField == undefined ? column.DataField : column.SortField;
							if (sortField == sortColumn) {
								return { index: i, column: sortField };
							}
						}
						return null;
					}
				},
				setSortIcon: function (column, sortClause) {
					var th = $("a[data-column='" + column + "']", JohnGrid.$table).parent();
					$(".icon-chevron-up, .icon-chevron-down", JohnGrid.$table).remove();

					if (sortClause != undefined) {
						if (sortClause.indexOf("DESC") != -1) {
							th.append("<i class='icon-chevron-down'></i>");
						} else {
							th.append("<i class='icon-chevron-up'></i>");
						}
					}
				}
			},

			utilities: {
				gridMode: "",
				gridModes: { selecting: "selecting", inserting: "inserting", editing: "editing" },
				selectedItem: null,
				init: function () {
					var errorMsgTemplate = '<div class="alert" style="display:none;"></div>';
					$(errorMsgTemplate).insertBefore(JohnGrid.$table);
				},
				getContext: function () {
					switch (this.gridMode) {
						case this.gridModes.selecting:
							return JohnGrid.selectHelpers.$detailTemplate;
						case this.gridModes.inserting:
							return JohnGrid.insertHelpers.$insertTemplate;
						case this.gridModes.editing:
							return JohnGrid.editHelpers.$editTemplate;
						default:
							throw "grid mode wasn't set correctly.";
					}
				},
				clearMessage: function () {
					JohnGrid.$table.prev().hide();
				},

                /**
                 * If message is null, this means that the first parameter is the message. If the xhr status indicates we're simply probably not logged in (unauthorized), change the message accordingly.
                 * @param {object} xhr 
                 * @param {string} message 
                 */
				setError: function (xhr, message) {
				    message = message != null ? (xhr.status === 401 ? "You are no longer logged in. We are redirecting you to the login page..." : message) : arguments[0];
					JohnGrid.$table.prev().addClass("alert-error").removeClass("alert-info").html(message).show();
					JohnGrid.setGridLoading(false);
					window.scrollTo(0, 0);
				},
				setInfo: function (message) {
					JohnGrid.$table.prev().addClass("alert-info").removeClass("alert-error").html(message).show();
				},
				setUpCancelBtn: function () {
					$(JohnGrid.cancelClass, JohnGrid.selectHelpers.$detailTemplate).on("click", this.cancelClick);
					$(JohnGrid.cancelClass, JohnGrid.insertHelpers.$insertTemplate).on("click", this.cancelClick);
					$(JohnGrid.cancelClass, JohnGrid.editHelpers.$editTemplate).on("click", this.cancelClick);
				},
				cancelClick: function () {
					JohnGrid.utilities.selectedItem = null;
					//JohnGrid.utilities.clearForm(); //taken out, since it only needs to be cleared before filling (selectclick, editclick, insertclick)
					JohnGrid.utilities.gridMode = "";
					JohnGrid.utilities.clearMessage();

					var templates = [JohnGrid.selectHelpers.$detailTemplate, JohnGrid.insertHelpers.$insertTemplate, JohnGrid.editHelpers.$editTemplate];
					for (var i = templates.length - 1; i >= 0; i--) {
						var template = templates[i];
						if (template != null) {
							template.hide();
						}
					}
					JohnGrid.$table.fadeIn('slow');
					JohnGrid.utilities.onSwapped();
				},
				swap: function (show, hide) {
					this.clearMessage();
					hide.fadeOut('fast', function () {
						show.fadeIn('slow');
					});
					this.onSwapped();
				},
				onSwapped: function() {
				},
				clearForm: function () {
					var context = this.getContext();
					//clear
					if (JohnGrid.utilities.gridMode == JohnGrid.utilities.gridModes.selecting) {
						$("[data-name]", context).html("");
					} else {
						$("input:not(input[type='button'], input[type='checkbox'], input[type='radio'])", context).val("");
						$("input[type='checkbox'], input[type='radio']", context).prop("checked", false);
						$("select option", context).first().prop("selected", true);
						$("textarea", context).val("");
					}
				},
				addActionItems: function (context) {
					if (context == JohnGrid.selectHelpers.$detailTemplate) {
						context.prepend(JohnGrid.htmlHelpers.backToGridBtn());
					} else {
						var needToAddActions = $(".JohnGridActions", context).length <= 0;
						if (needToAddActions) {
							context.append(JohnGrid.htmlHelpers.johnGridActions(false));
							var btnSave = $(".btnSave", context);
							btnSave.on("click", JohnGrid.utilities.saveItem);
							//Utilities.setDefaultButton(context, btnSave); --this can be confusing when save form is complex...
						}
					}
				},
				getItemForRowClick: function ($tdAnchor) { //get's item for when edit or delete is clicked
					var itemIndex = $tdAnchor.parent().parent().attr("data-itemIndex"), //stored on the tr element
						item = JohnGrid.currentDataSource[itemIndex];
					return item;
				},
				handleResponse: function (jsonResponse, successCallBack) {
					Utilities.handleAJAXResponse(jsonResponse, successCallBack, function (error) {
						JohnGrid.utilities.setError(error);
					});
				},
				saveItem: function (e) {
					JohnGrid.utilities.clearMessage();
					var $btn = $(this),
						loading = $btn.next(),
						item = JohnGrid.utilities.getItemFromTemplate(),
						errors = JohnGrid.utilities.validateItem(item);

					if (errors.length <= 0) {
						$btn.hide();
						loading.show();
						item.method = "save";
						console.log(item);
						JohnGrid.utilities.beforeSave(item);
						$.post(JohnGrid.datasourceURL, item, function (response) {
							JohnGrid.utilities.handleResponse(response, function (respObj) {
								JohnGrid.databind();
								JohnGrid.utilities.cancelClick(); //when creating new, primary key is empty, so can't stay here, lest they click save again (creates another...)
								JohnGrid.utilities.setInfo("Saved Successfully");
								JohnGrid.utilities.afterSave(item);
							});
						})
						.error(function (xhr) {
							JohnGrid.utilities.setError(xhr, "Something went wrong, while saving.");
						})
						.complete(function () {
							$btn.show();
							loading.hide();
						});
					} else {
						JohnGrid.utilities.setError(errors.join("<br />"));
					}
				},
				beforeSave: function (item) {
				},
				afterSave: function (item) {
				},
				getItemFromTemplate: function () {
					//create object to pass to server...

					//first encode values of html boxes...
					$("textarea[data-html]").each(function () {
						var $this = $(this),
							value = $this.val();

						$this.val(Utilities.htmlEncode(value));
					});

					var context = this.getContext(),
						item = {},
						nameVals = $("input, select, textarea", context).serializeArray();

					for (var i = nameVals.length - 1; i >= 0; i--) {
						var nameVal = nameVals[i],
							property = nameVal.name,
							value = nameVal.value,
							newProperty = item[property];

						if (newProperty != undefined && newProperty instanceof Array) {
							item[property].push(value); //add to previously started collection
						} else if (newProperty != undefined) {
							item[property] = [newProperty, value]; //start a collection
						} else {
							item[property] = value; //add simple property
						}
					}

					//csv arrays
					for (var property in item) {
						if (item[property] instanceof Array) {
							item[property] = item[property].join(",");
						}
					}

					return item;
				},
				validateItem: function (parameterizedItem) {
					return [];
					//user should implement this to do any client validation for an item before they're saved. It should return an array of error strings.
				}
			},

			htmlHelpers: {
				loadingImg: function (show) {
					var display = show ? '' : 'style="display:none;"',
						template = '<img src="https://adestinn2blob.blob.core.windows.net/images/loading.gif" alt="loading..." {0} />';
					return template.format(display);
				},
				johnGridActions: function () {
					template = '<div class="JohnGridActions">' +
										'<button type="button" class="btn btn-primary btnSave"> <i class="icon-ok icon-white"></i> Save&nbsp;&nbsp;&nbsp;</button>' +
										'{0}&nbsp;' +
										'{1}' +
									'</div>';
					return template.format(this.loadingImg(false), this.backToGridBtn());
				},
				backToGridBtn: function () {
					return '<button type="button" class="btn btnCancel"> <i class="icon-circle-arrow-left"></i>&nbsp;{0}</button>'.format(JohnGrid.UIComponents.BackButtonText);
				}
			},

			UIComponents: {
				BackButtonText: "Back To Grid",
				NoRecordsText: "No Records"
			}
		}
		return JohnGrid;
	};

	//need to have a way to identify individual instances, so I can have a script that takes care of handling all their hashChanges
	return CreateJohnGrid;
});
